import { render, staticRenderFns } from "./PendingBusinesses.vue?vue&type=template&id=b4d7c7ec&scoped=true"
import script from "./PendingBusinesses.vue?vue&type=script&lang=js"
export * from "./PendingBusinesses.vue?vue&type=script&lang=js"
import style0 from "./PendingBusinesses.vue?vue&type=style&index=0&id=b4d7c7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d7c7ec",
  null
  
)

export default component.exports